/**
 * modify-security-questions-client-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

export interface SecurePrompt {
  prompt : string;
  response : string;
}

export class ModifySecurityQuestionsClientResponse extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.CRSP_MODIFY_SECURITY_QUESTIONS;

  constructor (public prompts : SecurePrompt[])
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/modify-security-questions-client-response.ts